<template>
  <div>
    <!-- 判断是否在空白页打开 -->
    <template v-if="!isOneself">
      <div class="app-wrapper">
        <!-- 系统标题 -->
        <div class="system-title" @click="goHome">
          <div class="image">
            <img src="../assets/railway.png" alt srcset />
          </div>
          <div class="title">{{ systemTitle }}</div>
        </div>
        <!-- 左侧菜单 -->
        <ElMenu />
        <!-- 右侧展示内容 -->
        <div class="main-container">
          <HeaderNav class="header-main" />
          <AppContent class="app-main" />
        </div>
      </div>
    </template>
    <!-- 如果在空白页打开则不显示框架 -->
    <template v-else>
      <AppContent />
    </template>
  </div>
</template>

<script>
import ElMenu from "./components/ElMenu/index.vue";
import HeaderNav from "./components/HeaderNav.vue";
import AppContent from "./components/AppContent.vue";
export default {
  data() {
    return {
      // 默认页面在框架内显示
      isOneself: false,
      // 系统标题
      systemTitle: ""
    };
  },
  components: {
    ElMenu,
    HeaderNav,
    AppContent
  },
  mounted() {
    // 初始化加载一次判断是否在空白页打开
    this.isOneself = this.$route.meta.oneself;
    // 从缓存中获取系统标题
    this.getLocalUserInfo();
  },
  methods: {
    goHome() {
      // 这里也需要的是本地的域名 + 端口  process.VUE_APP_PORT
      // 判断当前路径是否是 '/homepage'
      if (this.$route.path === "/homePage") {
        // 如果当前已经是 /homepage，刷新页面
        window.location.reload();
      } else {
        // 如果当前路径不是 /homepage，使用 replace 跳转到 /homepage
        this.$router.replace("/homePage");
      }
    },
    // 从缓存中获取系统标题
    getLocalUserInfo() {
      let access_token = localStorage.getItem("access_token");
      if (access_token) {
        this.systemTitle = "6C数据中心";
      }
    }
  },
  watch: {
    // 监听route变化
    $route: function (newVal) {
      // 从缓存中获取系统标题
      this.getLocalUserInfo();
      // 判断页面是否在空白页打开
      this.isOneself = newVal.meta.oneself;
    }
  }
};
</script>

<style lang="less" scoped>
.app-wrapper {
  position: relative;
  height: 100%;
  width: 100%;

  // 系统标题
  .system-title {
    display: flex;
    // position: fixed;
    justify-content: space-around;
    align-items: center;
    color: white;
    width: 200px;
    height: 50px;
    top: 0;
    left: 0;
    background-color: #545c64;
    padding: 0px 10px;
    box-sizing: border-box;

    .image {
      cursor: pointer;
      width: 35px;
      height: 35px;
      border-radius: 20px;
      overflow: hidden;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .title {
      cursor: pointer;
      font-family: "楷体";
      font-weight: 700;
      font-size: 16px;
      padding-right: 30px;
    }
  }

  // 左侧菜单
  .sidebar-container {
    -webkit-transition: width 0.28s;
    transition: width 0.28s;
    width: 200px !important;
    background-color: white;
    height: 100%;
    position: fixed;
    font-size: 0px;
    top: 50px;
    bottom: 0;
    left: 0;
    z-index: 1001;
    overflow: hidden;
    box-shadow: 4px 0 10px rgba(0, 0, 0, 0.1);

    /* 添加阴影 */
    &>div {
      width: 201px !important;
    }
  }

  // 右侧主题内容
  .main-container {
    -webkit-transition: margin-left 0.28s;
    transition: margin-left 0.28s;
    position: fixed;
    width: calc(100vw - 200px);
    top: 50px;
    right: 0;
    bottom: 0;
    left: 200px;

    // width: 100%;
    // 头部导航
    .header-main {
      position: fixed;
      height: 50px;
      width: 100%;
      left: 200px;
      right: 0;
      top: 0;
      display: flex;
      align-items: center;
      padding-left: 15px;
      box-sizing: border-box;
      // border-bottom: 1px solid rgba(0, 0, 0, 0.2);
    }

    // 内容展示区
    .app-main {
      position: relative;
      height: 95vh;
      width: 100%;
      overflow: auto;
      background-color: #f0f0f0;
    }
  }
}
</style>
